/* @flow */
import React from 'react';

const getNikeFlowUrl = () => {
  if (typeof window === 'undefined') {
    return 'https://flow-test.nike.com';
  }

  const host = window.location.hostname.toLowerCase();
  return host.indexOf('prod-') === 0 || host.indexOf('prod.') === 0
    ? 'https://flow.nike.com'
    : 'https://flow-test.nike.com';
};

const SUPPORT_CHANNEL_URL = 'https://nike.enterprise.slack.com/archives/C0AJ8BM4GBS';

const bannerText = 'As part of our transition to NikeFlow and the retirement of legacy and redundant tools, the PARC CBD and Mass CBD applications (non-NBY) will be decommissioned on 11/13/2026. We encourage you to begin your transition to NikeFlow as soon as you read this message. For any questions or assistance, please reach out to ';

const DecommissionBanner = () => (
  <div className="parc-decommission-banner">
    <div className="parc-decommission-banner__message">
      <span className="parc-decommission-banner__icon">i</span>
      <span>
        {bannerText}
        <a
          className="parc-decommission-banner__link"
          href={SUPPORT_CHANNEL_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          #nikeflow-support-footwear
        </a>
        .
      </span>
    </div>
    <a
      className="parc-decommission-banner__cta"
      href={getNikeFlowUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      TAKE ME TO NIKEFLOW
    </a>
  </div>
);

export default DecommissionBanner;



// WEBPACK FOOTER //
// ./src/components/DecommissionBanner/DecommissionBanner.js